import styled from "styled-components";

const ReportExcelModalStyled = styled.div`
`

export default ReportExcelModalStyled;